import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import { IProps } from './interface';

export const RenderLastValue = memo<IProps>(({ series, renderLastValue }) => {
  if (!series || !series?.length || !renderLastValue) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={(theme) => ({
        backgroundColor: '#e7e7e7',
        borderLeft: `5px solid ${theme.palette.secondary.main}`,
        padding: '10px 20px',
        borderTopRightRadius: 4,
        borderBottomRightRadius: 4,
      })}
    >
      <Typography
        component="span"
        variant="body2"
        fontWeight={400}
        sx={{ lineHeight: 1 }}
      >
        Atual
      </Typography>

      <Typography
        data-testid="current-value"
        component="span"
        fontWeight={700}
        textTransform="uppercase"
      >
        {renderLastValue(
          series?.[0]?.data?.[series?.[0]?.data?.length - 1]?.[1]
        )}
      </Typography>
    </Box>
  );
});
